import React, { useState } from "react";

const StatementList = () => {
  const [txtStatements, setTxtStatements] = useState([]);
  const [statements, setStatements] = useState([]); // Processed data
  const [selectedIndex, setSelectedIndex] = useState(null);

  const handleTxtUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.name.endsWith(".txt")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const content = e.target.result;
        parseTxtFile(content);
      };
      reader.readAsText(file);
    } else {
      alert("Please upload a valid .txt file.");
    }
  };

  const parseTxtFile = (content) => {
    try {
      const statements = content
        .trim()
        .split(/\n(?=\d{2}:\d{2}:\d{2}:\d{2})/) // Split by lines starting with timestamps
        .map((segment, index) => {
          const lines = segment.trim().split("\n");
          const timestamps = lines[0]?.match(/(\d{2}:\d{2}:\d{2}:\d{2})/g) || [];
          const start = timestamps[0] || "[No Start]";
          const end = timestamps[1] || "[No End]";
          const speaker = lines[1] || "[No Speaker]";
          const text = lines.slice(2).join(" ").trim();
  
          return {
            start,
            end,
            speaker,
            text,
            clipName: `Clip1.mp4`, // Default clip name
          };
        });
  
      setTxtStatements(statements);
      setStatements(statements);
      console.log("Parsed Statements:", statements);
    } catch (error) {
      alert("Error parsing .txt file. Please check the file format.");
      console.error("Parsing Error:", error);
    }
  };
  

  const exportEDL = () => {
    console.log("Exporting EDL with rearranged statements:", statements);

    let currentTimeSeconds = 0; // Start timeline at 0 seconds

    // Header: Include TITLE and FCM
    const header = `TITLE: Generated_EDL\nFCM: NON-DROP FRAME\n\n`;

    const edlBody = statements
      .map((s, index) => {
        const segmentNumber = (index + 1).toString().padStart(3, "0");

        // Convert timestamps to seconds
        const duration =
          timestampToSeconds(s.end) - timestampToSeconds(s.start);

        // Set timeline start and end based on source duration
        const timelineStart = secondsToTimestamp(currentTimeSeconds);
        const timelineEnd = secondsToTimestamp(currentTimeSeconds + duration);

        // Increment current time for the next clip
        currentTimeSeconds += duration;

        return `${segmentNumber}  AX       AA/V  C        ${s.start} ${s.end} ${timelineStart} ${timelineEnd}\n` +
               `* FROM CLIP NAME: ${s.clipName}\n` +
               `* AUDIO LEVEL AT ${timelineStart} IS -0.00 DB  (REEL AX A1)\n` +
               `* AUDIO LEVEL AT ${timelineStart} IS -0.00 DB  (REEL AX A2)\n`;
      })
      .join("\n");

    const fullEdl = header + edlBody;

    console.log("Generated EDL Content:", fullEdl);

    // Create and download the .edl file
    const blob = new Blob([fullEdl], { type: "text/plain" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "generated.edl";
    link.click();
  };

  const timestampToSeconds = (timestamp) => {
    const [hours, minutes, seconds, frames] = timestamp.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds + frames / 30; // Assuming 30 fps
  };

  const secondsToTimestamp = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600)
      .toString()
      .padStart(2, "0");
    totalSeconds %= 3600;

    const minutes = Math.floor(totalSeconds / 60)
      .toString()
      .padStart(2, "0");
    const seconds = Math.floor(totalSeconds % 60)
      .toString()
      .padStart(2, "0");

    const frames = Math.round((totalSeconds % 1) * 30) // Assuming 30 FPS
      .toString()
      .padStart(2, "0");

    return `${hours}:${minutes}:${seconds}:${frames}`;
  };


  const deleteSelected = () => {
    if (selectedIndex !== null) {
      const newStatements = statements.filter((_, index) => index !== selectedIndex);
      setStatements(newStatements);

      // Adjust selectedIndex to handle cases where the last element is deleted
      if (selectedIndex >= newStatements.length) {
        setSelectedIndex(newStatements.length - 1);
      }
    }
  };


  const moveUp = () => {
    if (selectedIndex > 0) {
      const newStatements = [...statements];
      [newStatements[selectedIndex - 1], newStatements[selectedIndex]] = [
        newStatements[selectedIndex],
        newStatements[selectedIndex - 1],
      ];
      setStatements(newStatements);
      setSelectedIndex(selectedIndex - 1);
    }
  };

  const moveDown = () => {
    if (selectedIndex < statements.length - 1) {
      const newStatements = [...statements];
      [newStatements[selectedIndex + 1], newStatements[selectedIndex]] = [
        newStatements[selectedIndex],
        newStatements[selectedIndex + 1],
      ];
      setStatements(newStatements);
      setSelectedIndex(selectedIndex + 1);
    }
  };

  const selectStatement = (index) => {
    setSelectedIndex(index);
  };

  return (
    <div>
      {/* Import File */}
      <div style={{ marginTop: "10px" }}>
        <label>
          Import .txt File:
          <input
            type="file"
            onChange={(e) => {
              handleTxtUpload(e);
              e.target.value = null;
            }}
            accept=".txt"
            style={{ marginLeft: "5px" }}
          />
        </label>
      </div>

            {/* Statement Blocks Container */}
      {statements.length === 0 ? (
        <p style={{ marginTop: "20px", color: "red" }}>
          Please upload a .txt file to proceed.
        </p>
      ) : (
        <>
<div
  className="overflow-y-auto border rounded-lg p-4 bg-customLightBlue shadow-md h-[70vh] mt-6"
>
  {statements.map((statement, index) => (
    <div
      key={index}
      onClick={() => setSelectedIndex(index)}
      className={`p-4 mb-4 border rounded-lg cursor-pointer ${
        selectedIndex === index ? "bg-customBlue shadow-lg text-white" : "bg-white"
      }`}
    >
      <p><strong>Start:</strong> {statement.start}</p>
      <p><strong>End:</strong> {statement.end}</p>
      <p><strong>Speaker:</strong> {statement.speaker}</p>
      <p><strong>Text:</strong> {statement.text}</p>
    </div>
  ))}
</div>
          <div style={{ marginTop: "10px" }}>
          <div className="flex space-x-4 mt-4">
  <button
    onClick={deleteSelected}
    disabled={selectedIndex === null}
    className={`px-4 py-2 rounded-lg font-semibold text-white ${
      selectedIndex === null ? "bg-gray-300 cursor-not-allowed" : "bg-red-500 hover:bg-red-600"
    }`}
  >
    Delete
  </button>

  <button
    onClick={moveUp}
    disabled={selectedIndex === null || selectedIndex === 0}
    className={`px-4 py-2 rounded-lg font-semibold text-white ${
      selectedIndex === null || selectedIndex === 0
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-blue-500 hover:bg-blue-600"
    }`}
  >
    Move Up
  </button>

  <button
    onClick={moveDown}
    disabled={selectedIndex === null || selectedIndex === statements.length - 1}
    className={`px-4 py-2 rounded-lg font-semibold text-white ${
      selectedIndex === null || selectedIndex === statements.length - 1
        ? "bg-gray-300 cursor-not-allowed"
        : "bg-blue-500 hover:bg-blue-600"
    }`}
  >
    Move Down
  </button>

  <button
    onClick={exportEDL}
    className="px-4 py-2 rounded-lg font-semibold text-white bg-green-500 hover:bg-green-600"
  >
    Export EDL
  </button>
</div>

</div>

        </>
      )}
    </div>
  );
};

export default StatementList;
